import { render } from "./tradeReviewModal.vue?vue&type=template&id=bfd0faac&scoped=true&lang=pug"
import script from "./tradeReviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./tradeReviewModal.vue?vue&type=script&setup=true&lang=js"

import "./tradeReviewModal.vue?vue&type=style&index=0&id=bfd0faac&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd0faac"]])

export default __exports__